import React from 'react';

const LetterLoadingSkelton = () => {
  return (
    <div className='p-loading'>
      <div className='p-loading__inner'>
        <div className='p-loading__cover'>
          <img src='/img/common/logo.png' alt='SKALE' />
        </div>

        <div className='p-loading__text'>
          たった1つの
          <br />
          メッセージ
        </div>
      </div>
    </div>
  );
};

export default LetterLoadingSkelton;
